<template>
    <div class="bento-layout success">
        <!-- Status & Regal Container -->
        <div class="bento-header">
            <div class="bento-status">
                <div class="status-label">Status</div>
                <div class="status-value">Erfolg</div>
            </div>
            <div class="bento-slot">
                <div class="slot-label">Regal</div>
                <div class="slot-value">{{ formattedShelfLocation }}</div>
            </div>
        </div>

        <!-- Preview Container - Shows Success -->
        <div class="bento-preview">
            <div class="preview-content preview-success">
                <v-icon size="64" color="#4CAF50" class="success-pop">mdi-check-circle</v-icon>
                <p>Erfolgreich eingelagert!</p>
                <div class="order-info">{{ orderId }}</div>
            </div>
        </div>

        <!-- Message Container -->
        <div class="bento-message">
            <v-icon color="white" size="20">mdi-check</v-icon>
            <span>Artikel eingelagert</span>
            <span class="countdown">{{ countdown }}s</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SuccessState',
    props: {
        shelfLocation: {
            type: String,
            required: true
        },
        orderId: {
            type: String,
            required: true
        },
        sku: {
            type: String,
            required: true
        },
        countdown: {
            type: Number,
            default: 5
        },
        requiresExtraSlot: {
            type: Boolean,
            default: false
        },
        originalSlot: {
            type: String,
            default: ''
        }
    },
    computed: {
        formattedShelfLocation() {
            const slotName = this.shelfLocation || '';

            // If it's an extra slot starting with SPERRGUT_, format it nicely
            if (slotName.startsWith('SPERRGUT_')) {
                // Remove SPERRGUT_ prefix and convert to title case
                const name = slotName.replace('SPERRGUT_', '');
                // Convert underscores to spaces and capitalize first letter
                return name.replace(/_/g, ' ').toLowerCase()
                    .split(' ')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ');
            }

            return slotName;
        }
    }
};
</script>

<style scoped>
/* Bento Layout - Responsive Grid */
.bento-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
    overflow: hidden;
    gap: 8px;
    padding: 8px;
    box-sizing: border-box;
    background: #ffffff !important;
}

/* Success Theme */
.bento-layout.success .bento-status,
.bento-layout.success .bento-slot {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
}

.bento-layout.success .bento-message {
    background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
}

/* Header: Status & Regal */
.bento-header {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    height: auto;
}

.bento-status,
.bento-slot {
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
}

.status-label,
.slot-label {
    font-size: clamp(8px, 2vw, 10px);
    opacity: 0.9;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-value {
    font-size: clamp(12px, 3.5vw, 16px);
    font-weight: bold;
    margin-top: 2px;
}

.slot-value {
    font-size: clamp(14px, 4vw, 20px);
    font-weight: bold;
    margin-top: 2px;
    word-break: break-word;
    line-height: 1;
}

/* Preview Container - Flexible */
.bento-preview {
    flex: 1;
    min-height: 0;
    background: white;
    border-radius: 8px;
    border: 2px solid #e0e0e0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    gap: 12px;
}

.preview-success p {
    font-size: clamp(14px, 3.5vw, 18px);
    font-weight: bold;
    color: #4CAF50;
    margin: 0;
    text-align: center;
}

.order-info {
    font-size: clamp(11px, 2.5vw, 14px);
    color: #666;
    text-align: center;
    font-weight: 600;
}

/* Message Container */
.bento-message {
    flex-shrink: 0;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: white;
    font-size: clamp(11px, 2.8vw, 14px);
    font-weight: 500;
}

.countdown {
    margin-left: auto;
    font-weight: bold;
    font-size: clamp(12px, 3vw, 15px);
}

.success-pop {
    animation: pop 0.4s ease-out;
}

@keyframes pop {
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .bento-layout {
        gap: 6px;
        padding: 6px;
    }

    .bento-header {
        gap: 6px;
    }

    .bento-status,
    .bento-slot {
        padding: 5px;
    }

    .preview-content {
        padding: 4px;
        gap: 8px;
    }

    .bento-message {
        padding: 6px;
        gap: 6px;
    }
}
</style>
